import React from 'react';
import css from './read-input.module.css';
import FormField from '../../common/form-field';
import { FormComponentProps } from '../index';
import { useFormContext } from 'react-hook-form';

export function ReadInput({
  name,
  label,
  inline = false,
  column = false,
  horizontal = false,
  isNoteForm = false,
}: FormComponentProps & {
  name: string;
  label: string;
  inline?: boolean;
  column?: boolean;
  childrenText?: React.ReactNode;
  horizontal?: boolean;
  isNoteForm?: boolean;
}) {
  const { register } = useFormContext();

  return (
    <FormField
      inline={inline}
      label={label}
      labelFor={name}
      isNoteForm={isNoteForm}
      column={column}
      horizontal={horizontal}
    >
      <input
        {...register(name)}
        readOnly={true}
        type="text"
        className={css['readonly']}
        name={name}
      />
    </FormField>
  );
}
